import persistStore from '@/store/persistStore'

export const permissionAuth = (code: string) => {
  const storeData: any = persistStore.getState()
  const permissionCodes = storeData.permissionCodes || []
  return permissionCodes.includes(code)
}

export const permissionStyle = (code: string) => {
  return permissionAuth(code) ? {} : { display: 'none' }
}
